module.exports = __webpack_public_path__ + "img/img-contact-1.19dce56a.jpg";